import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as V4ThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import validate from 'validate.js';

import { chartjs } from './helpers';
import theme from './theme';
import palette from './theme/palette';
import typography from './theme/typography';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import validators from './common/validators';
import StoreContainer from './config/StoreContainer';
import Toast from './views/Toast';
import Loader from './views/Loader';

import { default as Routes } from './routes';

const browserHistory = createBrowserHistory();

const v4Overrides = (theme.components && theme.components.v4Overrides) || {};
const v4Props = (theme.components && theme.components.v4Props) || {};
const v4Theme = createMuiTheme({ palette, typography, overrides: v4Overrides, props: v4Props });

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <V4ThemeProvider theme={v4Theme}>
        <StoreContainer>
          <Loader />
          <Toast />
          <BrowserRouter history={browserHistory}>
            <Switch>
              <Routes />
            </Switch>
          </BrowserRouter>
        </StoreContainer>
      </V4ThemeProvider>
    </ThemeProvider>
  );
}

export default App;
